import Modal from '../../common/Modal';
import {
  DestructiveButton,
  DialogCard,
  DialogFooter,
  DialogText,
  DialogTitle,
  PrimaryButton,
  SecondaryButton,
} from './folderDialogStyles';

import type { FC, ReactNode } from 'react';

type Props = {
  title: ReactNode;
  description?: ReactNode;
  confirmLabel: ReactNode;
  cancelLabel?: ReactNode;
  /** Red confirm button for destructive actions (delete). */
  destructive?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/**
 * Lightweight confirm dialog on the shared folder-dialog pattern (left-aligned
 * Title Case heading, design-system footer buttons, close button from `Modal`).
 * Used for the Story Manager's delete confirmations; the app-wide `ConfirmModal`
 * is intentionally left untouched.
 */
const ConfirmDialog: FC<Props> = ({
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  destructive = false,
  onConfirm,
  onClose,
}) => {
  const ConfirmButton = destructive ? DestructiveButton : PrimaryButton;
  return (
    <Modal isOpen closeModal={onClose}>
      <DialogCard data-testid="confirm-dialog">
        <DialogTitle>{title}</DialogTitle>
        {description && <DialogText>{description}</DialogText>}
        <DialogFooter>
          <SecondaryButton
            type="button"
            onClick={onClose}
            data-testid="confirm-dialog-cancel"
          >
            {cancelLabel}
          </SecondaryButton>
          <ConfirmButton
            type="button"
            onClick={onConfirm}
            data-testid="confirm-dialog-confirm"
          >
            {confirmLabel}
          </ConfirmButton>
        </DialogFooter>
      </DialogCard>
    </Modal>
  );
};

export default ConfirmDialog;
